import firebase from 'firebase'
import firebaseui from 'firebaseui'
import {FIREBASE_CONFIG} from '@/config'
import store from '@/store'

require('firebase/firestore')

export default {
  context: null,
  uiConfig: null,
  ui: null,

  init (context) {
    this.context = context

    firebase.initializeApp(FIREBASE_CONFIG)
    this.uiConfig = {
      signInSuccessUrl: 'dashboard',
      signInOptions: [
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ]
    }
    this.ui = new firebaseui.auth.AuthUI(firebase.auth())

    this.storage = firebase.storage()
    this.storageRef = this.storage.ref()

    this.db = firebase.firestore()

    store.dispatch('setLoaderStatus', true)

    firebase.auth().onAuthStateChanged((user) => {
      store.dispatch('setLoaderStatus', false)

      if (user) {
        
        store.dispatch('setLoaderStatus', true)

        this.getUserDetails(user.uid)
          .then((response) => {
            const path = this.context.$router.history.current.path
            if (response.exists) {
              let data = response.data()
              data.ref = response.ref
              this.context.$store.dispatch('setCurrentUser', {...user, ...data})

              let requireAuth = this.context.$route.matched.some(record => record.meta.requireAuth)
              if (requireAuth && !user) {
                if (path !== '/auth') {
                  this.context.$router.push('/auth')
                  store.dispatch('setLoaderStatus', false)
                }
              } else if (user) {
                if (data.type === 'Student') {
                  console.log(path);
                  debugger
                  if (!path || (path && !path.startsWith('/student'))) {
                    this.context.$router.push('/student/profile')
                  } else {
                    this.context.$router.push(path)
                  }
                  store.dispatch('setLoaderStatus', false)
                } else if (data.type === 'Associate') {
                  if (data.status && data.status === 'Authorized') {
                    if (!path || (path && !path.startsWith('/associate'))) {
                      this.context.$router.push('/associate/applications')
                    } else {
                      this.context.$router.push(path)
                    }
                    store.dispatch('setLoaderStatus', false)
                  } else {
                    if (path !== '/associate/require-details') {
                      this.context.$router.push({path: '/associate/require-details'})
                    }
                    store.dispatch('setLoaderStatus', false)
                  }
                } else if (data.type === 'Employee') {
                  if (!path || (path && !path.startsWith('/employee'))) {
                    this.context.$router.push('/employee/applications')
                  } else {
                    this.context.$router.push(path)
                  }
                  store.dispatch('setLoaderStatus', false)
                } else if (data.type === 'Admin') {
                  if (!path || (path && !path.startsWith('/admin'))) {
                    this.context.$router.push('/admin/applications')
                  } else {
                    this.context.$router.push(path)
                  }
                  store.dispatch('setLoaderStatus', false)
                }
              }
            } else {
              if (path !== '/first-info') {
                this.context.$router.push('/first-info')
                store.dispatch('setLoaderStatus', false)
              }
              this.context.$store.dispatch('setCurrentUser', {...user})
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        this.context.$router.push('auth')
      }
    })
  },
  authForm (container) {
    this.ui.start(container, this.uiConfig)
  },
  createUserWithEmailAndPassword: (email, password) => {
    return firebase.auth().createUserWithEmailAndPassword(email, password)
  },
  signInWithGoogle () {
    const provider = new firebase.auth.GoogleAuthProvider()
    return firebase.auth().signInWithRedirect(provider)
  },
  signInWithEmail (payload) {
    return firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
  },
  sendPasswordResetEmail (payload) {
    return firebase.auth().sendPasswordResetEmail(payload.email)
  },

  // Queries on user - start
  user () {
    return this.context ? this.context.$store.user : null
  },
  getUserDetails (uid) {
    return this.db.collection('users').doc(uid).get()
  },
  setUserBasicDetails (uid, payload) {
    return this.db.collection('users').doc(uid).set(payload)
  },
  updateUserDetails (uid, payload) {
    return this.db.collection('users').doc(uid).update(payload)
  },
  getUsersByType (type) {
    return this.db.collection('users')
      .where('type', '==', type)
      .get()
  },
  getUsersByTypeAndStatus (type, status) {
    return this.db.collection('users')
      .where('type', '==', type)
      .where('status', '==', status)
      .get()
  },
  updateUserDocuments (uid, payload) {
    const userRef = this.db.collection('users').doc(uid)
    return this.db.runTransaction((transaction) => {
      return transaction.get(userRef)
        .then((doc) => {
          let documents = doc.data().documents_uploaded || []
          documents.push(payload.doc)
          transaction.update(userRef, {documents_uploaded: documents, status: payload.status})
        })
    })
  },
  deleteUserDocument (uid, document) {
    const userRef = this.db.collection('users').doc(uid)
    return this.db.runTransaction((transaction) => {
      return transaction.get(userRef)
        .then((doc) => {
          let documents = doc.data().documents_uploaded || []
          const docIndex = documents.findIndex(x => x.url === document.url)
          documents.splice(docIndex, 1)
          transaction.update(userRef, {documents_uploaded: documents})
        })
    })
  },
  // Queries on user - end

  // Queries on school - start
  getAllSchools () {
    return this.db.collection('schools').get()
  },
  getSchools () {
    return this.db.collection('schools').where('display_status', '==', 1).get()
  },
  getSchool (id) {
    return this.db.collection('schools').doc(id).get()
  },
  addSchool (payload) {
    this.updateLovProvince(payload.province, payload.name)

    const key = `${payload.name}, ${payload.province} - ${payload.campus}`
    const ref = this.db.collection('schools').doc(key)
    return ref.set(payload)
      .then(() => {
          return ref
      })
  },
  updateSchool (id, payload) {
    return this.db.collection('schools').doc(id).update(payload)
  },
  // Queries on school - end

  // Queries on lov - start
  getLov () {
    return this.db.collection('lov').get()
  },
  updateLovProvince (province, college) {
    const provincesRef = this.db.collection('lov').doc('provinces')
    return this.db.runTransaction((transaction) => {
      return transaction.get(provincesRef)
        .then((doc) => {
          let provinces = doc.data()
          if (province in provinces) {
            provinces[province] = [...provinces[province], college]
          } else {
            provinces[province] = [college]
          }
          transaction.update(provincesRef, provinces)
        })
    })

    return this.db.collection('lov').doc('provinces').update({[province]: province})
  },
  updateLovStudyAreas (studyArea) {
    return this.db.collection('lov').doc('study_areas').update({[studyArea]: studyArea})
  },
  updateLovTutionFee (tutionFee) {
    const ref = this.db.collection('lov').doc('tution_fee')
    return this.db.runTransaction((transaction) => {
      return transaction.get(ref)
        .then((doc) => {
          const data = doc.data()
          if (!data.min || (data.min && data.min > tutionFee)) {
            data.min = tutionFee
          }
          if (!data.max || (data.max && data.max < tutionFee)) {
            data.max = tutionFee
          }
          transaction.update(ref, data)
        })
    })
  },
  updateLovApplicationFee (applicationFee) {
    const ref = this.db.collection('lov').doc('application_fee')
    return this.db.runTransaction((transaction) => {
      return transaction.get(ref)
        .then((doc) => {
          const data = doc.data()
          if (!data.min || (data.min && data.min > applicationFee)) {
            data.min = applicationFee
          }
          if (!data.max || (data.max && data.max < applicationFee)) {
            data.max = applicationFee
          }
          transaction.update(ref, data)
        })
    })
  },
  // Queries on lov - end

  // Queries on program - start
  getPrograms () {
    return this.db.collection('programs')
      .where('display_status', '==', true)
      .orderBy('school.province', 'asc')
      .orderBy('school.name', 'asc')
      .get()
  },
  getAllPrograms () {
    return this.db.collection('programs')
      .orderBy('school.province', 'asc')
      .orderBy('school.name', 'asc')
      .get()
  },
  getProgram (id) {
    return this.db.collection('programs').doc(id).get()
  },
  getSchoolTopPrograms (schoolRef, filters = null) {
    let query = this.db.collection('programs')
      .where('display_status', '==', true)
      .where('school.ref', '==', schoolRef)

    if (filters) {
      filters.forEach(filter => {
        query = query.where(filter.key, filter.operator, filter.value)
      })
    }

    return query
      .limit(2)
      .get()
  },
  getSchoolPrograms (schoolRef, filters = null) {
    let query = this.db.collection('programs')
      .where('display_status', '==', true)
      .where('school.ref', '==', schoolRef)

    if (filters) {
      filters.forEach(filter => {
        query = query.where(filter.key, filter.operator, filter.value)
      })
    }

    return query
      .get()
  },
  getSchoolProgramsBySchoolName (schoolName) {
    return this.db.collection('programs')
      .where('school.name', '==', schoolName)
      .get()
  },
  addProgram (payload) {
    this.db.collection('lov').doc('study_areas').update({[payload.area_of_study]: payload.area_of_study})
    const ielts = (payload.ielts + '').replace(/\./g, '_')
    this.db.collection('lov').doc('ielts').update({[ielts]: payload.ielts})

    const key = `${payload.name} - ${payload.school.name}, ${payload.school.province} - ${payload.school.campus}`
    const ref = this.db.collection('programs').doc(key)
    return ref.set(payload)
      .then(() => {
        return ref
      })
  },
  updateProgram (id, payload) {
    if (payload.area_of_study) {
      this.db.collection('lov').doc('study_areas').update({[payload.area_of_study]: payload.area_of_study})
    }
    if (payload.ielts) {
      const ielts = (payload.ielts + '').replace(/\./g, '_')
      this.db.collection('lov').doc('ielts').update({[ielts]: payload.ielts})
    }
    return this.db.collection('programs').doc(id).update(payload)
  },
  // Queries on program - end

  // Queries on applications - start
  addApplication (payload) {
    const userRef = payload.userRef
    return this.db.runTransaction((transaction) => {
      return transaction.get(userRef)
        .then((doc) => {
          const now = firebase.firestore.FieldValue.serverTimestamp()
          this.db.collection('applications').add({...payload, created_at: now, updated_at: now})

          let appliedCount = (doc.data().appliedCount || 0)
          transaction.update(userRef, {appliedCount: (appliedCount + 1)})
        })
    })
  },
  getAllApplications () {
    return this.db.collection('applications')
    .orderBy('updated_at', 'desc')
    .get()
  },
  getApplications (status) {
    return this.db.collection('applications')
      .where('status', '==', status)
      .orderBy('updated_at', 'asc')
      .get()
  },
  getUserApplications (userRef) {
    return this.db.collection('applications')
      .where('userRef', '==', userRef)
      .orderBy('updated_at', 'desc')
      .get()
  },
  getAssocApplications (assocRef) {
    return this.db.collection('applications')
      .where('source', '==', assocRef)
      .orderBy('updated_at', 'desc')
      .get()
  },
  assignApplication (id, payload) {
    const applicationRef = this.db.collection('applications').doc(id)
    return this.db.runTransaction((transaction) => {
      return transaction.get(applicationRef)
        .then((doc) => {
          if (!doc.data().assigned_to) {
            transaction.update(applicationRef, payload)
          }
        })
    })
  },
  applicationSetStatus (id, payload) {
    return this.db.collection('applications').doc(id).update(payload)
  },
  // Queries on applications - end

  // Queries on students - start
  getStudents (assocRef) {
    return this.db.collection('students')
      .where('associate', '==', assocRef)
      .get()
  },
  addStudent (payload) {
    return this.db.collection('students').add(payload)
  },
  getStudentDetails (id) {
    return this.db.collection('students').doc(id).get()
  },
  updateStudentDetails (id, payload) {
    return this.db.collection('students').doc(id).update(payload)
  },
  updateStudentDocuments (id, payload) {
    const studentRef = this.db.collection('students').doc(id)
    return this.db.runTransaction((transaction) => {
      return transaction.get(studentRef)
        .then((doc) => {
          let documents = doc.data().documents_uploaded || []
          documents.push(payload.doc)
          transaction.update(studentRef, {documents_uploaded: documents})
        })
    })
  },
  deleteStudentDocument (id, document) { 
    const studentRef = this.db.collection('students').doc(id)
    return this.db.runTransaction((transaction) => {
      return transaction.get(studentRef)
        .then((doc) => {
          let documents = doc.data().documents_uploaded || []
          const docIndex = documents.findIndex(x => x.url === document.url)
          documents.splice(docIndex, 1)
          transaction.update(studentRef, {documents_uploaded: documents})
        })
    })
  },
  // Queries on students - end

  // Overall - start
  uploadDocument (file) {
    const newFileName = `${file.name.split('.')[0]}_${+new Date()}.${file.name.split('.')[1]}`
    return this.storageRef.child('documents').child(newFileName).put(file, {
      contentType: file.type
    })
  },
  deleteDocument (document) {
    return this.storageRef.child('documents').child(document.name).delete()
  },
  // Overall - end

  // Notifications - start
  addNotification (text, to, from) {
    const now = firebase.firestore.FieldValue.serverTimestamp()
    return this.db.collection('notifications').add({
      text: text,
      to: to,
      from: from,
      read_status: false,
      read_by: null,
      created_at: now,
      updated_at: now})
  },
  getNotifications () {
    return this.db.collection('notifications')
      .where('to', '==', 'CanEd')
      .get()
  },
  updateNotification (id, payload) {
    return this.db.collection('notifications').doc(id).update(payload)
  },
  // Notifications - end

  getPendingAssociates () {
    return this.getUsersByTypeAndStatus('Associate', 'Details Submitted')
  },
  getAuthorizedAssociates () {
    return this.getUsersByTypeAndStatus('Associate', 'Authorized')
  },
  getRejectedAssociates () {
    return this.getUsersByTypeAndStatus('Associate', 'Rejected')
  },
  getOnholdAssociates () {
    return this.getUsersByTypeAndStatus('Associate', 'On Hold')
  },
  logout () {
    firebase.auth().signOut()
  }
}

export function getDocsFromCollection (array) {
  let data = []
  array.forEach(doc => {
    let docData = doc.data()
    data.push({...docData, ...{id: doc.id, ref: doc.ref}})
  })
  return data
}

export function getObjectFromCollection (array) {
  let data = {}
  array.forEach(doc => {
    data[doc.id] = doc.data()
  })
  return data
}



// WEBPACK FOOTER //
// ./src/firebase.js